var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP200(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 254,
    viewBox: "0 0 25 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5822 192.737H9.49289C9.22503 192.737 9.01074 192.483 9.01074 192.165L9.01074 184.737H15.0107V192.165C15.0107 192.483 14.7965 192.737 14.5822 192.737Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.01074 122.737H12.0107V167.737H8.01074C8.01074 167.737 7.43931 138.937 4.01074 122.737Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0107 122.737H12.0107V167.737H16.0107C16.0107 167.737 16.5822 138.937 20.0107 122.737Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01074 127.737C8.01074 125.528 9.8016 123.737 12.0107 123.737V123.737C14.2199 123.737 16.0107 125.528 16.0107 127.737V186.737C16.0107 187.841 15.1153 188.737 14.0107 188.737H10.0107C8.90617 188.737 8.01074 187.841 8.01074 186.737V127.737Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0107 106.737H2.01074L2.01074 122.737C2.01074 123.841 6.48789 124.737 12.0107 124.737C17.5336 124.737 22.0107 123.841 22.0107 122.737L22.0107 106.737Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0076 109.69L24.0076 27.7366C24.0076 26.3291 23.2534 25.6434 22.0193 25.0402L17.6313 22.8955L12.0777 20.2817L5.90711 23.2306L2.06761 25.0402C0.764929 25.6434 0.0107422 26.8497 0.0107422 28.2572L0.0107422 109.737C0.0107422 110.841 5.38332 111.737 12.0107 111.737C18.6382 111.737 24.0107 110.841 24.0107 109.737C24.0107 109.721 24.0097 109.706 24.0076 109.69Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 25,
    height: 92
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0076 109.69L24.0076 27.7366C24.0076 26.3291 23.2534 25.6434 22.0193 25.0402L17.6313 22.8955L12.0777 20.2817L5.90711 23.2306L2.06761 25.0402C0.764929 25.6434 0.0107422 26.8497 0.0107422 28.2572L0.0107422 109.737C0.0107422 110.841 5.38332 111.737 12.0107 111.737C18.6382 111.737 24.0107 110.841 24.0107 109.737C24.0107 109.721 24.0097 109.706 24.0076 109.69Z",
    fill: "#F5F7F9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0107422,
    y: 24.7366,
    width: 6,
    height: 87,
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.0107,
    y: 24.7366,
    width: 6,
    height: 87,
    fill: "#E5ECF0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.0773 20.6845C14.6522 20.6845 16.7395 19.8744 16.7395 18.875C16.7395 17.8756 14.6522 17.0654 12.0773 17.0654C9.5024 17.0654 7.41504 17.8756 7.41504 18.875C7.41504 19.8744 9.5024 20.6845 12.0773 20.6845Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8525 21.7562C19.4813 19.6116 17.3558 18.0031 14.9561 17.3329C14.4762 17.668 13.3792 17.869 12.008 17.869C10.7053 17.869 9.67684 17.668 9.12834 17.3999C6.72865 18.1371 4.53466 19.6116 3.16341 21.8232C2.68347 22.6275 2.47778 23.6328 2.47778 24.5711L2.47778 33.7529C2.47778 34.4901 3.16341 35.0262 3.91759 34.9592C6.18015 34.5571 8.85409 34.289 11.8023 34.289C14.9561 34.289 17.6986 34.5571 20.0983 34.9592C20.8525 35.0933 21.5381 34.5571 21.5381 33.7529L21.5381 24.437C21.5381 23.4988 21.3324 22.5605 20.8525 21.7562Z",
    fill: "#B0E298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44214 23.2978C4.40201 22.0244 5.77326 21.0862 7.21307 20.3489C7.96726 20.0138 8.72144 19.7458 9.54419 19.5447C10.3669 19.3436 11.1897 19.2766 12.0124 19.2766C13.6579 19.2766 15.372 19.6117 16.8118 20.3489C18.3202 21.0191 19.6229 22.0244 20.5827 23.2978C19.2115 22.4266 17.8402 21.7564 16.4004 21.2872C15.6462 21.0862 14.9606 20.8851 14.2064 20.7511C13.4523 20.617 12.6981 20.55 11.9439 20.55C10.4355 20.55 8.92713 20.8181 7.48732 21.2202C6.18464 21.7564 4.74482 22.4266 3.44214 23.2978Z",
    fill: "#8BB975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0107 55.7366H8.01074L8.01074 83.6481H16.0107L16.0107 55.7366Z",
    fill: "#B0E298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3386 61.3696H9.78027L9.78027 77.5953H14.3386L14.3386 61.3696Z",
    fill: "#FBF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3386 61.3696H9.78027V61.7059H14.3386V61.3696Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3386 77.343H9.78027V77.6793H14.3386V77.343Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3386 72.0463H9.78027V72.3825H14.3386V72.0463Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3386 66.6659H9.78027V67.0021H14.3386V66.6659Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.129 62.9749C12.4313 62.9749 12.6713 63.0585 12.8491 63.2258C13.0284 63.3917 13.118 63.6134 13.118 63.8908C13.118 64.1021 13.0511 64.3311 12.9175 64.5777C12.7853 64.8243 12.5521 65.1509 12.2179 65.5575H13.3094V66.0903H11.2471V66.0264C11.4871 65.7402 11.693 65.4833 11.8646 65.2558C12.0378 65.0269 12.1715 64.8375 12.2657 64.6878C12.3599 64.5366 12.4267 64.4082 12.4662 64.3025C12.5057 64.1968 12.5255 64.0875 12.5255 63.9744C12.5255 63.8335 12.4784 63.7154 12.3842 63.62C12.2915 63.5231 12.1784 63.4746 12.0447 63.4746C11.8046 63.4746 11.5555 63.6067 11.2972 63.871V63.2677C11.5691 63.0725 11.8464 62.9749 12.129 62.9749Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2931 68.2434C12.6151 68.2434 12.8704 68.3836 13.0587 68.6639C13.2486 68.9443 13.3436 69.3274 13.3436 69.8132C13.3436 70.3035 13.2502 70.6903 13.0633 70.9735C12.8764 71.2568 12.6212 71.3985 12.2976 71.3985C11.9695 71.3985 11.7097 71.2583 11.5183 70.9779C11.3283 70.6961 11.2334 70.3108 11.2334 69.822C11.2334 69.3347 11.3283 68.9502 11.5183 68.6683C11.7082 68.3851 11.9664 68.2434 12.2931 68.2434ZM11.8259 69.8397C11.8259 70.5427 11.9816 70.8943 12.2931 70.8943C12.5969 70.8943 12.7488 70.5244 12.7488 69.7846C12.7488 69.0933 12.5954 68.7476 12.2885 68.7476C11.9801 68.7476 11.8259 69.1116 11.8259 69.8397Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2989 73.4824C12.621 73.4824 12.8762 73.6226 13.0646 73.903C13.2545 74.1833 13.3495 74.5664 13.3495 75.0522C13.3495 75.5425 13.256 75.9293 13.0692 76.2126C12.8823 76.4958 12.6271 76.6375 12.3035 76.6375C11.9753 76.6375 11.7155 76.4973 11.5241 76.217C11.3342 75.9351 11.2393 75.5498 11.2393 75.0611C11.2393 74.5737 11.3342 74.1892 11.5241 73.9074C11.714 73.6241 11.9723 73.4824 12.2989 73.4824ZM11.8318 75.0787C11.8318 75.7818 11.9875 76.1333 12.2989 76.1333C12.6028 76.1333 12.7547 75.7634 12.7547 75.0236C12.7547 74.3323 12.6012 73.9866 12.2944 73.9866C11.986 73.9866 11.8318 74.3506 11.8318 75.0787Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4718 24.7721V33.7528C21.4718 34.49 20.8547 35.0262 20.032 34.8921C19.2778 34.7581 18.455 34.6911 17.5637 34.557L17.5637 23.1636C18.6607 23.5657 19.2778 23.9008 20.2377 24.3029C20.9918 24.504 20.9918 24.504 21.4718 24.7721Z",
    fill: "#8BB975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.54785 24.7741L2.54785 33.7549C2.54785 34.4921 3.16491 35.0282 3.98766 34.8942C4.74185 34.7602 5.5646 34.6931 6.45591 34.5591L6.45591 23.1656C5.35891 23.5678 4.74185 23.9029 3.78197 24.305C3.02779 24.5061 3.02779 24.5061 2.54785 24.7741Z",
    fill: "#8BB975"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -2.98926,
    y: -0.936157,
    width: 30.2949,
    height: 259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 253,
    fill: "white",
    transform: "translate(0.305664 0.0638428)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP200);
export default __webpack_public_path__ + "static/media/P200.732e5f5c3558ff51277a19d75ba07d5c.svg";
export { ForwardRef as ReactComponent };